import { addBreadcrumb } from '@sentry/react';

const FORCE_RELOAD_STORAGE_KEY = 'sentry.sw.forceReload';

/** Breadcrumb when the service worker asks the page to reload after a deploy. */
export const recordServiceWorkerForceReload = () => {
  addBreadcrumb({
    category: 'service-worker',
    message: 'FORCE_RELOAD received',
    level: 'info',
  });

  // Reload clears in-memory breadcrumbs — persist so the next boot can re-attach.
  try {
    sessionStorage.setItem(FORCE_RELOAD_STORAGE_KEY, new Date().toISOString());
  } catch {
    // sessionStorage may be unavailable (private mode / quota); breadcrumb above is best-effort.
  }
};

/** Re-attach a FORCE_RELOAD breadcrumb after the post-deploy page reload. */
export const restoreServiceWorkerForceReloadBreadcrumb = () => {
  try {
    const forcedAt = sessionStorage.getItem(FORCE_RELOAD_STORAGE_KEY);
    if (!forcedAt) return;

    sessionStorage.removeItem(FORCE_RELOAD_STORAGE_KEY);
    addBreadcrumb({
      category: 'service-worker',
      message: 'Page loaded after FORCE_RELOAD',
      level: 'info',
      data: { forcedAt },
    });
  } catch {
    // ignore
  }
};

/**
 * Listen for print intents so Sentry can show whether matchMedia('print') /
 * beforeprint fired before an error (e.g. Screen unmounting Navigation).
 */
export const registerPrintBreadcrumbs = () => {
  if (typeof window === 'undefined') return;

  window.addEventListener('beforeprint', () => {
    addBreadcrumb({
      category: 'print',
      message: 'beforeprint',
      level: 'info',
    });
  });

  window.addEventListener('afterprint', () => {
    addBreadcrumb({
      category: 'print',
      message: 'afterprint',
      level: 'info',
    });
  });

  const mediaQuery = window.matchMedia('print');
  mediaQuery.addEventListener('change', (event) => {
    addBreadcrumb({
      category: 'print',
      message: `matchMedia('print') ${event.matches ? 'entered' : 'exited'}`,
      level: 'info',
      data: { matches: event.matches },
    });
  });
};
